import {isPlatformBrowser} from '@angular/common';
import {ApplicationConfig, Injector, isDevMode, mergeApplicationConfig, PLATFORM_ID} from '@angular/core';
import {provideServiceWorker} from '@angular/service-worker';
import {provideTransloco} from '@jsverse/transloco';
import {
	AuthenticationService,
	InvitationService,
	MessageService,
	NotificationService,
	PresenceService,
	PrivateMessageService,
	ProfileCleanupService,
	ProfileImageService,
	ProfileService,
	RoomService,
	SendmailService,
	SettingsService,
	TchatService
} from '@services';
import {getApp} from 'firebase/app';
import {environment} from '../environments/environment';
import {TranslocoHttpLoader} from '../transloco-loader';
import {appConfigShared} from './app.config.shared';
import {BadgeService} from './services/community/badge.service';
import {PracticesService} from './services/community/practices.service';
import {FirebaseInitService} from './services/shared/firebase-init.service';

export const appConfig: ApplicationConfig = mergeApplicationConfig(appConfigShared, {
	providers: [
		{
			provide: FirebaseInitService,
			useFactory: (injector: Injector) => {
				const platformId = injector.get(PLATFORM_ID);
				const isBrowser = isPlatformBrowser(platformId);
				const service = new FirebaseInitService();
				if (isBrowser && typeof window !== 'undefined') {
					// Firebase is already initialized in main.ts, just get it
					const firebaseApp = getApp();
					service.initialize(firebaseApp);
				}
				return service;
			},
			deps: [Injector]
		},
		// Provide services only on client side (not needed for public pages like landing)
		BadgeService,
		PracticesService,
		ProfileCleanupService,
		ProfileImageService,
		ProfileService,
		PresenceService,
		RoomService,
		TchatService,
		InvitationService,
		MessageService,
		NotificationService,
		SendmailService,
		PrivateMessageService,
		AuthenticationService,
		SettingsService,
		provideServiceWorker('ngsw-worker.js', {
			enabled: environment.production,
			registrationStrategy: 'registerWhenStable:5000'
		}),
		provideTransloco({
			                 config: {
				                 availableLangs: ['fr', 'en', 'de', 'it', 'es'],
				                 defaultLang: 'en',
				                 reRenderOnLangChange: true,
				                 prodMode: !isDevMode()
			                 },
			                 loader: TranslocoHttpLoader
		                 })
	]
});
